import { Link } from "react-router-dom";
import { useAuth } from "../../auth/useAuth";
import { automapAdminPortalPath } from "../../constants/automapAdminPortalPaths";

/** Shared account navigation links and sign-out for header and sidebar menus. */
const UserMenuActions = ({ onNavigate, className = "auth-user-menu__action" }) => {
  const { user, logout, hasPartnerAccess } = useAuth();

  if (!user) {
    return null;
  }

  const close = () => onNavigate?.();

  return (
    <>
      <p className="auth-user-menu__email">{user.email}</p>
      {hasPartnerAccess() ? (
        <Link to={automapAdminPortalPath("dashboard")} className={className} role="menuitem" onClick={close}>
          Partner Dashboard
        </Link>
      ) : null}
      <Link to="/account/dashboard" className={className} role="menuitem" onClick={close}>
        Dashboard
      </Link>
      <Link to="/account/saved-searches" className={className} role="menuitem" onClick={close}>
        Saved Searches
      </Link>
      <Link to="/account/favorites" className={className} role="menuitem" onClick={close}>
        Favorites
      </Link>
      <Link to="/account/profile" className={className} role="menuitem" onClick={close}>
        Profile
      </Link>
      <Link to="/account/security" className={className} role="menuitem" onClick={close}>
        Account Security
      </Link>
      <Link to="/account/consents" className={className} role="menuitem" onClick={close}>
        Legal &amp; Consent
      </Link>
      <Link to="/account/notifications" className={className} role="menuitem" onClick={close}>
        Notifications
      </Link>
      <Link to="/account/preferences" className={className} role="menuitem" onClick={close}>
        Preferences
      </Link>
      <button
        type="button"
        className={className}
        role="menuitem"
        onClick={() => {
          close();
          logout();
        }}
      >
        Sign out
      </button>
    </>
  );
};

export default UserMenuActions;
